/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Kind_TipInputs */

const en_us2_board_kind_tip = /** @type {(inputs: Board_Kind_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip`)
};

const pt_br2_board_kind_tip = /** @type {(inputs: Board_Kind_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dica`)
};

const pt_pt2_board_kind_tip = /** @type {(inputs: Board_Kind_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dica`)
};

/** @type {(inputs: Board_Kind_TipInputs) => LocalizedString} */
const es_419_board_kind_tip = en_us2_board_kind_tip;

/** @type {(inputs: Board_Kind_TipInputs) => LocalizedString} */
const fr_fr2_board_kind_tip = en_us2_board_kind_tip;

/** @type {(inputs: Board_Kind_TipInputs) => LocalizedString} */
const de_de2_board_kind_tip = en_us2_board_kind_tip;

/** @type {(inputs: Board_Kind_TipInputs) => LocalizedString} */
const it_it2_board_kind_tip = en_us2_board_kind_tip;

/**
* | output |
* | --- |
* | "Tip" |
*
* @param {Board_Kind_TipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_kind_tip = /** @type {((inputs?: Board_Kind_TipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Kind_TipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_kind_tip(inputs)
	if (locale === "es-419") return es_419_board_kind_tip(inputs)
	if (locale === "pt-PT") return pt_pt2_board_kind_tip(inputs)
	if (locale === "fr-FR") return fr_fr2_board_kind_tip(inputs)
	if (locale === "de-DE") return de_de2_board_kind_tip(inputs)
	if (locale === "it-IT") return it_it2_board_kind_tip(inputs)
	return en_us2_board_kind_tip(inputs)
});
export { board_kind_tip as "board.kind_tip" }